import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/tailwind.css';
import gtagPlugin from './plugins/gtag';

require('./assets/global.css');

let gtagId = '';
if (process.env.VUE_APP_ENDPOINTS === 'production') {
  gtagId = 'G-CLE7G3BBMC';
} else if (process.env.VUE_APP_ENDPOINTS === 'staging') {
  gtagId = 'G-E428652J03';
} else {
  gtagId = 'G-61VR9N5G6C';
}

createApp(App)
  .use(store)
  .use(router)
  .use(gtagPlugin, { id: gtagId })
  .mount('#app');

router.afterEach((to) => {
  if (window.gtag) {
    window.gtag('config', gtagId, {
      page_path: to.fullPath,
      page_title: document.title,
    });
  }
});
